export const PHASE_THINK_CHAT = 21283154;
export const PHASE_THINK_TANK = 21283155;
export const STATUS_DEAD = 21227337;
export const TYPE_NORMAL = 21283817;
export const TYPE_INDIVIDUAL = 21283818;



// WEBPACK FOOTER //
// ./src/constants/tables.js